import React from "react";
import "../../Styles/certified/colan.css";

export default function Finzly() {
  return (
    <>
      <div className="colan-certified-details-section">
        <div className="colan-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="colan-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="colan-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="colan-certified-badge"
            />
            <div className="colan-certified-company-names">
              <a href="https://colaninfotech.com/career/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/colan/colan.png"
                alt="Walkzero Logo"
                className="colan-certified-company-logo"
              />
            </a>
              <h1 className="colan-certified-full-name">
               Colan Infotech Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="colan-certified-details-right">
            <img
              src="/assets/colan/colan_6.jpeg"
              alt="Finzly Office"
              className="colan-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="colan-certified-description">
          <h2>
            Why Colan Infotech Pvt Ltd  is an Outstanding Workplaces
          </h2>
          <p>
            Colan Infotech was started in 2009, we are in the business of digitizing firms and keep businesses relevant in today’s age. The company is headquartered in Chennai with 500+ employees, always prepared to meet the technology needs of any kind of business anywhere in the world. Our company holds the recognition of CMMI level 3 and being a NASSCOM partner.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="colan-certified-info-cards">
          <div className="colan-certified-info-card">
            <div className="colan-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">500+ Employees</div>
          </div>
          <div className="colan-certified-info-card">
            <div className="colan-certified-info-title">INDUSTRY</div>
            <div className="colan-certified-info-value"> IT Software and Services

</div>
          </div>
          <div className="colan-certified-info-card">
            <div className="colan-certified-info-title">CONNECT</div>
            <div className="colan-certified-info-icons">
              <span className="colan-certified-icon-round">
                <a href="https://colaninfotech.com/career/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="colan-certified-icon-round">
                <a href="https://www.linkedin.com/company/colan-infotech-private-limited/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="colan-certified-icon-round">
                <a href="https://www.facebook.com/ColanInfotechPvtLtd/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="colan-certified-info-card">
            <div className="colan-certified-info-title">LOCATION (HQ)</div>
            <div className="colan-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="colan-certified-recognition-section">
          <h2 className="colan-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="colan-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="colan-certified-recognition-image"
            />
          </div>
          <div className="colan-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="colan-certified-life-section">
          <h2 className="colan-certified-life-title">
            Life at Colan Infotech Pvt Ltd
          </h2>
          <div className="colan-certified-life-gallery">
            <div className="colan-certified-life-col">
              <img src="/assets/colan/colan_5.jpeg" alt="Office 1" className="colan-certified-life-img" />
              <img src="/assets/colan/colan_2.jpeg" alt="Team 1" className="colan-certified-life-img" />
            </div>
            <div className="colan-certified-life-col colan-certified-life-center">
              <img src="/assets/colan/colan_1.jpeg" alt="Main Office" className="colan-certified-life-img colan-certified-life-img-large" />
            </div>
            <div className="colan-certified-life-col">
              <img src="/assets/colan/colan_3.jpeg" alt="Office 2" className="colan-certified-life-img" />
              <img src="/assets/colan/colan_4.jpeg" alt="Team 2" className="colan-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
